import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { getIsGlobalUser } from '../../../features/loginSystem/selectors';

const GlobalRejectCommentContent = ({ state = {}, setState }) => {
  const isGlobalUser = useSelector(getIsGlobalUser);
  const { formatMessage } = useIntl();
  const rejectCommentHasError = !!state.rejectCommentHasError;

  const value = _.get(state, `globalRejectComment`, '');

  const error = (rejectCommentHasError && !value) || value.length > 500;
  const errorText =
    error && value.length < 500
      ? formatMessage({
          id: 'prompt.contentRejectCommentMissingDataError'
        })
      : '';

  const label = formatMessage({
    id: 'prompt.contentRejectCommentTextFieldLabel'
  });
  return (
    <>
      <Typography variant="body1">
        <FormattedMessage id="prompt.contentRejectCommentText" />
      </Typography>
      <TextField
        id="filled-multiline-static"
        label={label}
        multiline
        required
        fullWidth
        rows="3"
        variant="filled"
        value={value}
        error={error}
        helperText={errorText}
        onChange={event => {
          setState({
            globalRejectComment: event.target.value
          });
        }}
        style={{ marginTop: '1em' }}
        key="reject-comment"
      />
      <p
        style={{
          textAlign: 'right',
          marginTop: '0px',
          ...(value.length > 500 ? { color: '#E00751' } : '')
        }}
      >
        {value.length}/500
      </p>
      <p style={{ marginBottom: 0 }}>
        <Typography variant="caption">
          <FormattedMessage id="prompt.contentRejectCommentNoteGlobalUser" />
        </Typography>
      </p>
    </>
  );
};

const transformRejectDataToApiFormat = (promptState = {}) => {
  let approvalData = {};
  _.forOwn(promptState.globalRejectComment, () => {
    approvalData = {
      ...approvalData,
      globalRejectComment: promptState.globalRejectComment
    };
  });
  return approvalData;
};

export default GlobalRejectCommentContent;
export { transformRejectDataToApiFormat };
